const NAMESPACE = "automationRuleTable";

const KEYS = {
    noProgramWideActionsMessage: "noProgramWideActionsMessage",
    noActionsMessage: "noActionsMessage",
    noValidationsMessage: "noValidationsMessage",
    noProgramActionsMessage: "noProgramActionsMessage",
    orderColumnHeader: "orderColumnHeader",
    frequencyRuleColumnHeader: "frequencyRuleColumnHeader",
    conditionRuleColumnHeader: "conditionRuleColumnHeader",
    errorMessageRuleColumnHeader: "errorMessageRuleColumnHeader",
    actionRuleColumnHeader: "actionRuleColumnHeader",
    continueProcessingRuleColumnHeader: "continueProcessingRuleColumnHeader",
    frequencyEveryTimeMessage: "frequencyEveryTimeMessage",
    frequencyOnlyFirstMessage: "frequencyOnlyFirstMessage",
    conditionAlwaysMessage: "conditionAlwaysMessage",
    continueProcessingMessage: "continueProcessingMessage",
    stopProcessingMessage: "stopProcessingMessage",
    stopInfoConditionMessage: "stopInfoConditionMessage",
    stopInfoActionMessage: "stopInfoActionMessage"
};

const MESSAGES = {
    [KEYS.noProgramWideActionsMessage]: {
        value: "No program wide project action rules found.",
        comment: "Empty Rule Table Message"
    },
    [KEYS.noActionsMessage]: {
        value: "No action rules found.",
        comment: "Empty Rule Table Message"
    },
    [KEYS.noValidationsMessage]: {
        value: "No validation rules found.",
        comment: "Empty Rule Table Message"
    },
    [KEYS.noProgramActionsMessage]: {
        value: "No program action rules found.",
        comment: "Empty Rule Table Message"
    },
    [KEYS.orderColumnHeader]: { value: "#", comment: "Order Rule Column Header Name" },
    [KEYS.frequencyRuleColumnHeader]: { value: "Frequency", comment: "Frequency Rule Column Header Name" },
    [KEYS.conditionRuleColumnHeader]: { value: "Condition", comment: "Condition Rule Column Header Name" },
    [KEYS.errorMessageRuleColumnHeader]: { value: "Error Message", comment: "Error Message Rule Column Header Name" },
    [KEYS.actionRuleColumnHeader]: { value: "Action", comment: "Action Column Header Name" },
    [KEYS.continueProcessingRuleColumnHeader]: {
        value: "Continue Processing",
        comment: "Continue Processing Column Header Name"
    },
    [KEYS.frequencyEveryTimeMessage]: {
        value: "Every time",
        comment: "Indicates that rule is evaluated every time trigger is met"
    },
    [KEYS.frequencyOnlyFirstMessage]: {
        value: "Only first time",
        comment: "Indicates that rule is evaluated only the first time a trigger is met"
    },
    [KEYS.conditionAlwaysMessage]: {
        value: "Always",
        comment: "Indicates that a rule condition will always be true and the action taken"
    },
    [KEYS.continueProcessingMessage]: {
        value: "Continue",
        comment: "Indicates that rules will continue to be processed after this one"
    },
    [KEYS.stopProcessingMessage]: {
        value: "Stop processing rules",
        comment: "Indicates that rule processing will stop after this one."
    },
    [KEYS.stopInfoConditionMessage]: {
        value: "A 'Stop processing rules' action was taken.",
        comment:
            "Text to display in the Condition column of the Automation Rule History table," +
            " on the informational row after the rule that caused automation processing to stop"
    },
    [KEYS.stopInfoActionMessage]: {
        value: "No further actions were processed.",
        comment:
            "Text to display in the Action column of the Automation Rule History table," +
            " on the informational row after the rule that caused automation processing to stop"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
